const Disclaimer = () => {
  return (
    <div data-testid="disclaimer-page" className="pt-32 pb-20 bg-white">
      <div className="container-main">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl text-[#2D2D2D] mb-8">Disclaimer</h1>
          <p className="text-[#6E6E6E] mb-8">Last updated: December 2024</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">1. General Information</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                The information provided on the Decors Genius website is for general informational 
                purposes only. All information is provided in good faith; however, we make no 
                representation or warranty of any kind regarding the accuracy, adequacy, validity, 
                reliability, or completeness of any information on the site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">2. No Professional Advice</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                The content on this website does not constitute professional design advice. 
                Individual project recommendations are provided only after personal consultation 
                and assessment of your specific needs and space.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">3. Pricing Disclaimer</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Pricing varies based on project scope and materials selected. All estimates 
                are provided in writing before project commencement. Prices shown on this 
                website or discussed during consultations are estimates only and may change 
                based on final project specifications.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">4. Results Disclaimer</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                While we strive for excellence in every project, individual results may vary 
                based on factors including but not limited to: existing conditions, material 
                availability, and environmental factors. We do not guarantee specific outcomes 
                or property value changes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">5. External Links</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Our website may contain links to external websites. We are not responsible 
                for the content, accuracy, or availability of these external sites. The 
                inclusion of any link does not imply endorsement by Decors Genius.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">6. Images and Portfolio</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Images on this website are representative of our work style and capabilities. 
                Some images may be used for illustrative purposes. Actual project results 
                depend on individual client requirements and specifications.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">7. Limitation of Liability</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Under no circumstances shall Decors Genius be liable for any direct, indirect, 
                special, incidental, or consequential damages arising from your use of, or 
                inability to use, this website or our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">8. Contact Us</h2>
              <p className="text-[#6E6E6E] leading-relaxed">
                If you have questions about this Disclaimer, please contact us at:<br />
                Email: support@decorsgenius.store<br />
                Phone: +1-888-880-1455
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
